module.exports = __webpack_public_path__ + "static/media/programma_python.65c9e1ac.pdf";